import { resolve } from "inversify-react";
import * as moment from "moment";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import images from "src/assets/images";
import { actions as homeActions } from "../../actions/home.actions";
import { actions } from "../../actions/main.actions";
import { actions as nameActions } from "../../actions/name.actions";
import Button from "../../core/ui/button";
import RaritySelect from "../../core/ui/data-component/rarity-select";
import Grid, { Col } from "../../core/ui/grid";
import Icon from "../../core/ui/icon";
import FormInput from "../../core/ui/input";
import LateInput from "../../core/ui/late-input";
import Modal from "../../core/ui/modal";
import BlockchainService from "../../services/blockchain.service";
import IdentityService from "../../services/identity.service";
import PrivateFileSystem from "../../services/private.filesystem.service";
import ToastService from "../../services/toast.service";
import ArtsDataService from "../arts/arts.data.service";
import GalleryGrid from "../arts/gallery-grid";
import { IApplicationState } from "../../typings";

interface IAccountCollectionProps {
    identity: IdentityService;
    urlPreffix: string;
}

type AccountCollectionProps = IAccountCollectionProps & typeof actions & typeof homeActions & RouteComponentProps<any>;
interface IAccountCollectionState {
    showModal: boolean;
    title: string;
    date?: string;
    // certDate?: string;
    uid?: string;
    tah?: string;
    rarity?: string;
    editionType?: string;
    dimensions?: string;
    created_in?: string;
    publicEditionNumber?: string;
    medium?: string;
    editionCount: number;
    invalidCard: boolean;
    wizardStage: 0 | 1;
    dateError?: string[];
    titleError?: string[];
    editionNameError?: string[];
    generalErrors?: string[];
    created_inError?: string[];
    dimensionsError?: string[];
    editionError?: string[];
    mediumError?: string[];
    cardToken: string;
    rarityFilter?: number;
    loading: boolean;
    textFilter?: string;
    art_token_photo?: any;
    artist?: any;
    prove_of_purchase?: any;
    signature_photo?: any;

    art_token_photoError?: string[];
    artistError?: string[];
    prove_of_purchaseError?: string[];
    signature_photoError?: string[];
    certDateErrors?: string[];

    iAgree: boolean;
    paying: boolean;
    creationCost: number;
}

class AccountCollection extends React.Component<AccountCollectionProps, IAccountCollectionState> {
    @resolve(ArtsDataService)
    public dataService: ArtsDataService;

    @resolve(IdentityService)
    public identityService: IdentityService;

    @resolve(PrivateFileSystem)
    public privateFileSystem: PrivateFileSystem;

    @resolve(ToastService)
    public toastService: ToastService;

    @resolve
    public blockChainService: BlockchainService;

    private baseCreationCost: number;

    constructor(props: any) {
        super(props);
        this.state = {
            showModal: false,
            title: "",
            wizardStage: 0,
            uid: "",
            tah: "",
            editionType: "limited-edition",
            date: moment(Date.now()).format("YYYY-MM-DD"),
            editionCount: 1,
            invalidCard: true,
            cardToken: "",
            iAgree: false,
            paying: false,
            loading: false,
            creationCost: 0,
        };
    }

    public async componentDidMount() {
        this.props.changeLocation("collection");
        if (this.identityService.isArtist) {
            const creationCost = await this.dataService.getArtworkCreationCost();
            this.baseCreationCost = creationCost;
            this.setState({ creationCost });
        }
    }

    public handleModal = () => {
        this.setState({ showModal: !this.state.showModal });
        this.cleanData();
    }

    public getSecondWizardStage = () => {
        return (
            <React.Fragment>
                <FormInput
                    label="Max. number of Editions"
                    style="dark"
                    value={this.state.editionCount}
                    type="number"
                    onChange={(e) => this.setState({ editionCount: e })}
                    errors={this.state.titleError}
                    placeholder="Max. number of Editions"
                    min={1}
                />
                <FormInput
                    label="Mold created in"
                    style="dark"
                    value={this.state.created_in}
                    onChange={(e) => this.setState({ created_in: e })}
                    errors={this.state.created_inError}
                    placeholder="Mold created in"
                />
                <FormInput
                    style="dark"
                    value={this.state.date}
                    onChange={(e) => this.setState({ date: e })}
                    errors={this.state.dateError}
                    type="number"
                    min={1980}
                    max={new Date().getFullYear()}
                    label="Creation year"
                />
                <div className="token-creation-btn-container">
                    <a className="back-action" onClick={() => this.setState({ wizardStage: 0 })}>
                        BACK
                    </a>
                    {this.state.loading && <img src={images.loading} className="loading-icon fa-spin" />}
                    {!this.state.loading && (
                        <Button
                            disabled={!this.blockChainService.isValid || !this.state.editionCount}
                            onClick={this.createToken}
                            presentation="light"
                            as={<button />}
                        >
                            Create certificate
                        </Button>
                    )}
                </div>
            </React.Fragment>
        );
    }

    public getFirstWizardStage = () => {
        let fullName = "";
        if (this.props.identity.userInfo !== undefined) {
            fullName = this.props.identity.userInfo.name;
            if (this.props.identity.userInfo.last_name !== undefined) {
                fullName = fullName + " " + this.props.identity.userInfo.last_name;
            }
        }
        return (
            <React.Fragment>
                <FormInput
                    label="Artwork title"
                    style="dark"
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e })}
                    errors={this.state.titleError}
                    placeholder="Write the title of your art piece"
                />
                <FormInput label="Artist Name" style="dark" disabled={true} value={fullName} />
                <FormInput
                    label="Medium"
                    style="dark"
                    value={this.state.medium}
                    onChange={(e) => this.setState({ medium: e })}
                    errors={this.state.mediumError}
                    placeholder="Medium"
                />
                <FormInput
                    label="Dimensions"
                    style="dark"
                    value={this.state.dimensions}
                    onChange={(e) => this.setState({ dimensions: e })}
                    errors={this.state.dimensionsError}
                    placeholder="250x100x400"
                />
                <RaritySelect
                    placeholder="Select category"
                    label="Choose category"
                    value={this.state.rarity}
                    onChange={(e) => this.setState({ rarity: e.id })}
                />
                <div className="token-creation-btn-container">
                    <div className="margin" />
                    <Button onClick={() => this.setState({ wizardStage: 1 })} presentation="light" as={<button />}>
                        Continue
                    </Button>
                </div>
            </React.Fragment>
        );
    }

    public createToken = () => {
        if (this.state.editionCount && this.state.editionCount < 1) {
            this.toastService.showToast("Error", "The edition count must be greater than 1", "error");
            this.setState({ loading: false });
            return;
        }
        if (!this.state.title || !this.state.rarity || !this.state.medium || !this.state.dimensions || !this.state.editionCount) {
            this.toastService.showToast("Error", "You must provide all fields for the arttoken", "error");
            this.setState({ loading: false });
            return;
        }

        this.setState({ loading: true });
        this.dataService
            .createToken(
                this.state.title,
                this.state.date || "",
                this.state.editionCount,
                this.state.rarity,
                this.state.dimensions,
                this.state.medium,
                this.state.created_in,
            )
            .then((r) => {
                this.setState({
                    showModal: false,
                    title: "",
                    rarity: undefined,
                    wizardStage: 0,
                    loading: false,
                    dimensions: undefined,
                    medium: undefined,
                    created_in: undefined,
                });
                this.props.history.push(`/art/edit/${r.id}`);
            })
            .catch((error) => {
                console.log("Error");
                this.setState({
                    loading: false,
                    certDateErrors: error.cert_date,
                    dateError: error.creation_date,
                    generalErrors: error.non_field_errors,
                    titleError: error.title,
                });
            });
    }

    public cleanData = () => {
        this.setState({
            art_token_photo: undefined,
            artist: undefined,
            prove_of_purchase: undefined,
            signature_photo: undefined,
        });
    }

    public certifyToken = () => {
        this.setState({ paying: true });
        this.dataService
            .certifyToken(
                this.state.art_token_photo,
                this.state.artist,
                this.state.prove_of_purchase,
                this.state.signature_photo,
                this.state.cardToken,
                this.identityService.userInfo ? this.identityService.userInfo.id : null,
                this.state.dimensions || "",
            )
            .then((result) => {
                this.setState({
                    cardToken: "",
                    invalidCard: true,
                    prove_of_purchase: undefined,
                    art_token_photo: undefined,
                    artist: undefined,
                    signature_photo: undefined,
                });
                this.setState({ showModal: false });
                this.cleanData();
                this.setState({ paying: false });
                this.toastService.showToast("Artwork certification", "Please wait for our feedback as an email message", "success");
            })
            .catch((error) => {
                if ("message" in error) {
                    this.toastService.showToast("Payment error", error.message, "warn");
                }
                this.setState({
                    prove_of_purchaseError: error.prove_of_purchase,
                    signature_photoError: error.signature_photo,
                    artistError: error.artist,
                    dimensionsError: error.dimensions,
                    certDateErrors: error.cert_date,
                    art_token_photoError: error.art_token_photo,
                    cardToken: "",
                    invalidCard: true,
                    paying: false,
                });
            });
    }

    public getModalContent = () => {
        if (this.identityService.isArtist) {
            return (
                <React.Fragment>
                    <div className="indicator-tokenCreation mobile">
                        <h3 onClick={() => this.setState({ wizardStage: 0 })}>{this.state.wizardStage + 1}/2</h3>
                    </div>
                    <div className="token-creation-form">
                        <Grid>
                            <Col size={1}>
                                <h1 className="token-creation-title">
                                    <strong>Certify</strong> your artwork instantly
                                </h1>

                                <p className="token-creation-description">
                                    Register the ownership of your work and create a <strong>Digital Certificate of Authenticity</strong>{" "}
                                    encrypted and linked to the blockchain.
                                    <br />
                                </p>
                                <p className="token-creation-description">Accesible at any time.</p>
                                <p className="token-creation-cost">Credits available: {this.identityService.userInfo ? this.identityService.userInfo.credits : 0}
                                    <span className="euros"> ({this.identityService.userInfo ? this.identityService.userInfo.credits : 0}€) </span>
                                </p>
                                <p className="token-creation-cost">Creation cost: {this.state.creationCost} credits
                                    <span className="euros"> ({this.state.creationCost}€) </span>
                                </p>
                            </Col>
                            <Col className="col-divider" />
                            <div className="mobile divider" />
                            <Col size={1}>
                                <div className="token-form">
                                    <div className="indicator-tokenCreation not-mobile">
                                        <h3>{this.state.wizardStage + 1}/2</h3>
                                    </div>
                                    {this.state.wizardStage === 0 && this.getFirstWizardStage()}
                                    {this.state.wizardStage === 1 && this.getSecondWizardStage()}
                                </div>
                            </Col>
                        </Grid>
                    </div>
                </React.Fragment>
            );
        }
    }

    public render() {
        const addNewTokenButton = (
            <div key="create-token" onClick={this.handleModal} className="token-creation-btn">
                <Icon type="close" />
                <label>{this.identityService.isArtist ? "ARTWORK CERTIFICATE" : "ARTWORK REQUEST"}</label>
            </div>
        );

        const modalContent = this.getModalContent();

        return (
            <React.Fragment>
                <Modal
                    closable={true}
                    type="grey"
                    size="medium"
                    className="mobile1"
                    onCancel={this.handleModal}
                    visible={this.state.showModal}
                >
                    {this.identityService.isVerified && modalContent}
                    {!this.identityService.isVerified && (
                        <p className="not-verified-creation">
                            Welcome to EncryptoArt! Start creating certificates after you complete the registration process. Go to the
                            Account page and follow the steps.
                        </p>
                    )}
                </Modal>
                <Grid centered={true} className="mobile">
                    <Col size={60}>{this.identityService.isArtist && addNewTokenButton}</Col>
                </Grid>
                <Grid centered={true}>
                    <Col size={80}>
                        <div className="art-header">
                            <LateInput
                                placeholder="Type to filter by title"
                                onChange={(e) => this.setState({ textFilter: e })}
                                delay={20}
                            />

                            <div className="artist-name">
                                <h4 className="type"></h4>
                                <h4 className="name"></h4>
                            </div>
                            <div className="section-name"></div>
                            <div className="list-filter">
                                <h4 className="filter-name">FILTER BY</h4>
                                <RaritySelect
                                    type="fill"
                                    extraData={[
                                        {
                                            id: undefined,
                                            display_name: "All",
                                        },
                                    ]}
                                    onChange={(e) => this.setState({ rarityFilter: e.id })}
                                    placeholder="Filter by category"
                                />
                            </div>
                        </div>
                        <GalleryGrid
                            showWarning={true}
                            noChangeLocation={true}
                            rarityFilter={this.state.rarityFilter}
                            textFilter={this.state.textFilter}
                            urlPreffix={this.props.urlPreffix}
                            showTemplate={true}
                            request={(pageSize, pageIndex, rarity?, text?) =>
                                this.dataService.getCollectionItems(pageSize, pageIndex, rarity, text)
                            }
                            userId={this.identityService.userInfo}
                            header={this.identityService.isArtist && <div className="not-mobile"> {addNewTokenButton} </div>}
                        />
                    </Col>
                </Grid>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        identity: state.identity,
    };
}
export default withRouter(connect(mapStateToProps, { ...actions, ...nameActions, ...homeActions })(AccountCollection));



// WEBPACK FOOTER //
// ./src/components/account/account-collection.tsx